<p>profit-loss works!</p>
